import React from "react";

const CitizenServices = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Details of Citizen Services Delivered by the Organization</h5>
      </div>

      <div className="about-box p-4 rounded shadow-lg ">
        <div className="table-responsive">
          <table className="table table-striped table-bordered">
            <thead>
              <tr>
                <th>Sr.No.</th>
                <th>Name / Particulars of the service</th>
                <th>
                  Current mode of delivery of servcie (Mannual / Electronic)
                </th>
                <th>
                  Time-lines prescribed for delivery of the service, if any
                </th>
                <th>Service Priority (1st, 2nd, 3rd etc.)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>
                  Supply of Foundation seeds of Various crops to the seed
                  growers subject to availability.
                </td>
                <td>Manual</td>
                <td>Against 100% apyment within 2 working days</td>
                <td>1st</td>
              </tr>
              <tr>
                <td>2</td>
                <td>
                  Supply of seed to the farmers through sales outlets of HSDC
                  &amp; other Goverment Agencies subject to availability.
                </td>
                <td>Manual</td>
                <td>Same working day.</td>
                <td>2nd</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Disposal of complaints with regard to Quality of Seeds</td>
                <td>Manual</td>
                <td>
                  Reply to the complainant within two days of receipt of
                  complaint and its disposal within 15 days after reply to the
                  complainant by the committee constituted for attending the
                  complaint.
                </td>
                <td>1st</td>
              </tr>
              <tr>
                <td>4</td>
                <td>
                  Intake of Raw Seed at Seed Processing Plant on the basis of
                  Final field inspection report issued by Seed Certification
                  Agency
                </td>
                <td>Manual</td>
                <td>
                  Delivery of Raw seed at Seed Processing Plant of HSDC on the
                  same working day.
                </td>
                <td>4th</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Advance payment of Raw Seeds to the Seed Growers</td>
                <td>Manual / By Cheque</td>
                <td>
                  80% payment of Minimum of Support Price of respective crop
                  within 5 working days.
                </td>
                <td>5th</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Final payment to the concerned seed Growers</td>
                <td>Manual / By Cheque</td>
                <td>
                  Balance 20% final payment of certified seed after getting
                  successful test reports from seed testing lab subject to
                  lifting of undersize seed and settlement of all dues within 5
                  wokring days.
                </td>
                <td>6th</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CitizenServices;
